import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useFeatureFlag(flagKey: string) {
  return useQuery({
    queryKey: ['feature-flag', flagKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('is_enabled')
        .eq('flag_key', flagKey)
        .maybeSingle();
      
      if (error) {
        console.error('Error fetching feature flag:', error);
        return false;
      }
      
      return data?.is_enabled ?? false;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
